import { Injectable, LOCALE_ID, Inject } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { Router } from '@angular/router';
import { catchError, map } from 'rxjs/operators';
import {
  HttpInterceptor, HttpRequest, HttpHandler, HttpSentEvent, HttpHeaderResponse, HttpProgressEvent,
  HttpResponse, HttpUserEvent, HttpErrorResponse, HttpEvent
} from '@angular/common/http';
import { AuthenticationService } from '../services/authentication.service';
import { UserStorageService } from '@app/core/services/user-storage.service';

const TOKEN_HEADER_KEY = 'Authorization';

@Injectable({
  providedIn: 'root'
})
export class TokenInterceptor implements HttpInterceptor {
  regexIso8601 = /^(\d{4}-[01]\d-[0-3]\dT[0-2]\d:[0-5]\d:[0-5]\d\.\d+)|(\d{4}-[01]\d-[0-3]\dT[0-2]\d:[0-5]\d:[0-5]\d)|(\d{4}-[01]\d-[0-3]\dT[0-2]\d:[0-5]\d)$/;
  constructor(
    @Inject(LOCALE_ID) public locale: string,
    private authenticationService: AuthenticationService,
    private userStorageService: UserStorageService,
    private router: Router) { }

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpSentEvent | HttpHeaderResponse | HttpProgressEvent | HttpResponse<any> | HttpUserEvent<any>> {
    // Add auth header
    if (this.userStorageService.getAccessToken() != null && !request.headers.get(TOKEN_HEADER_KEY)) {
      request = request.clone({
        headers: request.headers.set(TOKEN_HEADER_KEY, 'Bearer ' + this.userStorageService.getAccessToken()),
      });
    }

    request = request.clone({
      headers: request.headers.set('TimeZone', Intl.DateTimeFormat().resolvedOptions().timeZone).set('Locale', this.locale),
    });

    // proceed
    return next.handle(request).pipe(
      map((response: HttpEvent<any>) => {
        if (response instanceof HttpResponse) {
          this.convertDateStringsToDates(response.body);
        }
        return response;
      }),
      catchError((err: any) => {
        if (err instanceof HttpErrorResponse) {
          if (err.status === 401) {
            this.authenticationService.logOut();
            this.router.navigate(['/auth/sign-in']);
          }
        }

        return throwError(err);
      }));
  }

  convertDateStringsToDates(input: any) {
      // Ignore things that aren't objects.
      if (typeof input !== 'object') {
        return input;
      }

      for (const key in input) {

          if (!input.hasOwnProperty(key)) { continue; }

          const value = input[key];
          // Check for string properties which look like dates.
          if (typeof value === 'string' && value.match(this.regexIso8601)) {
              const milliseconds = Date.parse(value);
              if (!isNaN(milliseconds)) {
                  input[key] = new Date(milliseconds);
              }
          } else if (typeof value === 'object') {
              // Recurse into object
              this.convertDateStringsToDates(value);
          }
      }
  }
}
